import PropTypes from "prop-types";
import React from "react";
import { useParams } from "react-router-dom";

import { useNetworkMetadata } from "Flocknote/apiHooks";

import FnrEnrichedCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";

ReportCheckbox.propTypes = {
  makeReport: PropTypes.bool,
  setMakeReport: PropTypes.func,
  setShare: PropTypes.func,
  disabled: PropTypes.bool,
};

export default function ReportCheckbox({
  makeReport,
  setMakeReport,
  setShare,
  disabled,
}) {
  const [{ networkName }] = useNetworkMetadata();
  const { groupURL } = useParams();
  const isGroupReport = Boolean(groupURL);

  return (
    <FnrEnrichedCheckbox
      on={makeReport}
      disabled={disabled}
      toggleOn={() => {
        if (makeReport) {
          setShare(false);
          setMakeReport(false);
        } else {
          setMakeReport(true);
          setShare(true);
        }
      }}
      color="#00adbb"
    >
      {" "}
      {`Save this ${
        isGroupReport ? "Group " : ""
      }Report to the Reports section for ${networkName}`}
    </FnrEnrichedCheckbox>
  );
}